import { useEffect, useState } from "react";
import { ButtonPrimitive } from "@/components/ButtonPrimitive";
import { Flex } from "@/components/Flex/Flex";
import { Text } from "@/components/Text";
import { readStorage, writeStorage } from "@/utils/safe-storage";

const STORAGE_KEY = "lc-cookie-consent";

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = readStorage("local", STORAGE_KEY);
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    writeStorage("local", STORAGE_KEY, "accepted");
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Flex
      data-component="CookieConsent"
      align="center"
      justify="center"
      className="fixed inset-x-0 bottom-0 z-chrome p-4"
    >
      <Flex
        role="alert"
        direction={{ base: "column", lg: "row" }}
        align="center"
        gap={12}
        className="ds-alert bg-bg max-w-2xl shadow-lg"
      >
        <Text as="span" variant="body-sm" className="text-fg text-center">
          Продолжая использовать сайт, вы соглашаетесь с{" "}
          <a
            href="https://lenacareer.school/policy"
            target="_blank"
            rel="noopener noreferrer"
            className="ds-link ds-link-primary"
          >
            политикой обработки персональных данных
          </a>
        </Text>
        <ButtonPrimitive
          as="button"
          type="button"
          onClick={handleAccept}
          variant="solid"
          tone="brand"
          size="sm"
          className="shrink-0"
        >
          Понятно
        </ButtonPrimitive>
      </Flex>
    </Flex>
  );
}

CookieConsent.displayName = "CookieConsent";
